import { render, staticRenderFns } from "./MedalStandingRussiaTable.vue?vue&type=template&id=16f5db37&"
import script from "./MedalStandingRussiaTable.vue?vue&type=script&lang=js&"
export * from "./MedalStandingRussiaTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports